import { MessageTypeEnum } from 'api/MessagesApi';
import AudioEditor from 'components/Message/CreateMessageComponent/StepMessage/ManualCreation/AudioEditor/AudioEditor';
import TextEditor from 'components/Message/CreateMessageComponent/StepMessage/ManualCreation/TextEditor/TextEditor';
import VideoEditor from 'components/Message/CreateMessageComponent/StepMessage/ManualCreation/VideoEditor/VideoEditor';
import { useMessageService } from 'components/Message/useMessageService';
import './ManualCreation.css';

type AllProps = {
  initContent?: string;
  initTitle?: string;
  onNext: (shouldExit?: boolean) => void;
  onBack: () => void;
  goToDeliveryInfo: () => void;
};

function ManualCreation({ initContent, initTitle, onBack, onNext, goToDeliveryInfo }: AllProps) {
  const { message } = useMessageService();

  if (!message) return null;

  return (
    <div className="manual-creation create-message-component-full-height">
      {message.type === MessageTypeEnum.Text && (
        <TextEditor
          initContent={initContent}
          initTitle={initTitle}
          onNext={onNext}
          onBack={onBack}
          goToDeliveryInfo={goToDeliveryInfo}
        />
      )}

      {message.type === MessageTypeEnum.Audio && (
        <AudioEditor
          scriptText={initContent}
          initTitle={initTitle}
          onNext={onNext}
          onBack={onBack}
          goToDeliveryInfo={goToDeliveryInfo}
        />
      )}

      {message.type === MessageTypeEnum.Video && (
        <VideoEditor
          scriptText={initContent}
          initTitle={initTitle}
          onNext={onNext}
          onBack={onBack}
          goToDeliveryInfo={goToDeliveryInfo}
        />
      )}
    </div>
  );
}

export default ManualCreation;
